// extracted by mini-css-extract-plugin
module.exports = {"contentIcon":"SplitScreenSlider_contentIcon__EuAyy"};